<template>
  <div v-loading="loading">
    <p class="title">订单核算</p>
    <QS-h4-title title="退车核算" />
    <QS-column-box
      :label-width="labelWidth"
      separator=":"
      :source="source"
      :list="list"
    ></QS-column-box>
    <QS-h4-title title="网约运营信息" />
    <QS-column-box
      :label-width="labelWidth"
      separator=":"
      :source="source"
      :list="operationList"
    >
      <div class="alone">
        <el-form>
          <el-form-item :label-width="labelWidth + 'px'" label="备注图片:">
            <show-img-and-file :list="source.operationFlowPhotos" />
          </el-form-item>
        </el-form>
      </div>
    </QS-column-box>
    <QS-h4-title title="支付款项" />
    <el-table
      :data="source.orderSettlementItems"
      height="500"
      cell-class-name="custom-cell-class"
    >
      <el-table-column prop="title" label="支付内容" width="110">
        <template slot-scope="{ row }">
          {{ getText(row.payContent) }}
        </template>
      </el-table-column>
      <el-table-column label="付款方" width="100">
        <!-- slot-scope="" 必须写，否则会报错 -->
        <template slot-scope="">{{ orderData.customerName }}</template>
      </el-table-column>
      <el-table-column label="支付金额（元）" width="180">
        <template slot-scope="{ row }">
          {{ row.amount || '0.00' }}元
        </template>
      </el-table-column>
      <el-table-column label="备注" width="200px">
        <template slot-scope="{ row }">
          {{ row.remarks || '--' }}
        </template>
      </el-table-column>
      <el-table-column label="图片">
        <template slot-scope="{ row }">
          <div class="box-photos">
            <div class="item" v-for="(item, index) in row.photos" :key="index">
              <EnlargeImg :imgSrc="item.url" />
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <QS-h4-title title="核算结果" />
    <QS-column-box
      :label-width="100"
      separator=":"
      :source="source"
      :list="resultList"
    ></QS-column-box>
  </div>
</template>
<script>
import config from './config'
import { vehiclesettlement } from '@/api/domain/returnLease'
import { mapState } from 'vuex'
import moment from 'moment'

export default {
  inject: ['orderData'],
  data() {
    const { list, operationList, resultList } = config.call(this)
    return {
      labelWidth: 170,
      list,
      operationList,
      resultList,
      source: {
        orderSettlementItems: [],
      },
      stateEnum: {
        0: '待核算',
        1: '已完成',
        2: '审批中',
        3: '核算中',
        4: '核算失败',
      },
      loading: false,
      unitKey: [
        'receivableAmount',
        'toBeReceivedAmount',
        'receivableDeposit',
        'receivedDeposit',
        'operationFlowAmount',
        'operationFlowDeduct',
        'refundableDepositAmount',
        'refundableRentAmount',
        'needPatchAmount',
      ],
    }
  },
  created() {
    this.$store.dispatch('getPaymentMethods', { type: 'settlementFeeType' })
    this.getSettleInfo(this.orderData.id)
  },
  computed: {
    ...mapState({
      settleMentFeeList: (state) => state.global.settleMentFeeList, // 结算费项
    }),
  },
  methods: {
    // 获取支付内容文字
    getText(code) {
      return this.settleMentFeeList.filter(
        (settle) => settle.code === Number(code),
      )[0].name
    },
    // 获取结算详情
    getSettleInfo(orderId) {
      this.loading = true
      vehiclesettlement({ orderId })
        .then((res) => {
          this.loading = false
          if (res.code !== 1) return
          this.source = res.data || {}
          this.source.dailyRule =
            res.data.isSettlementRefund === 1
              ? '每月30天计算'
              : '期始月份自然天数计算'
          this.source.isSettlementRefund =
            res.data.isSettlementRefund === 1 ? '是' : '否'
          this.source.settlementState = this.stateEnum[
            Number(res.data.settlementState)
          ]
          // 需要加单位的字段
          this.unitKey.forEach((key) => {
            // 已收押金 如果是平移押金订单，则额外显示已平移金额
            if (
              key === 'receivedDeposit' &&
              this.source.transferredDeposit === 1
            ) {
              this.source[key] = `${this.source[key]}元（已平移：${
                this.source[key]
              }元）`
            } else {
              this.source[key] = `${this.source[key]}元`
            }
          })
          // 原订单已续约且原订单已截止时 合同截止时间用endD替代takeOverTime
          const { presentEntDate, endDate } = this.orderData
          const endD = presentEntDate || endDate
          if (!this.source.takeOverTime) {
            this.source.takeOverTime = moment(endD).format(
              'YYYY-MM-DD 23:59:59',
            )
          }

          this.hiddenDailyRule({
            performanceState: this.source.performanceState,
            state: this.orderData.state,
            payMode: this.orderData.payMode,
          })
          const { operationFlowPhotos } = res.data
          this.source.operationFlowPhotos = Array.isArray(operationFlowPhotos) ? operationFlowPhotos : this.getURL({ data: operationFlowPhotos })
        })
        .catch(() => {
          this.loading = false
        })
    },
    // 隐藏月付车款未足月计算规则
    hiddenDailyRule(data) {
      // 待履约订单退车 && 订单待核算及以后订单 &&  车款付款方式为：月付（整月）-4 /月付（自然月）-5  -->
      // const { performanceState, state, payMode } = data
      const { payMode } = data
      // 车款付款方式为：月付（整月）-4 /月付（自然月）-5
      if (![4, 5].includes(Number(payMode))) {
        const index = this.list.findIndex((item) => item.key === 'dailyRule')
        this.list.splice(index, 1)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.title {
  width: 100%;
  height: 40px;
  line-height: 40px;
  padding: 0 12px;
  font-weight: 600;
  font-size: 16px;
  color: #323233;
  margin-bottom: 14px;
}
.box-photos {
  display: flex;
  flex-wrap: wrap;

  .item {
    margin-left: 16px;
    width: 80px;
    height: 80px;

    &:nth-child(5n + 1) {
      margin-left: 0;
    }

    &:nth-child(n + 6) {
      margin-top: 30px;
    }
  }
}
</style>
